import {post} from "./request.js"


export function getSsInfo() {

    return post('/?s=App.AdminUser_MtSsUser.GetSsInfoFromSession', {
    });
}

export function getOrderList(shopId,freeword) {

    return post('/?s=App.Order_Order.OrderList', {
        serviceStatusList: ['2','3','4'],
        shopId:shopId,
        freeword:freeword
    });
}

export function uploadImage(file,orderId,fileName) {

    return post('/', {
        s:"App.Order_Order.uploadCarPhoto",
        file:file,
        orderId:orderId,
        fileName:fileName
    });
}


